import { Grid } from '@mui/material';
import React from 'react';
import { CircularSkeleton, RoundedSkeleton } from '../../Common/Skeleton';

function LoadingConversation() {
  return (
    <Grid display="flex" gap="12px" padding={2} bgcolor="#fff" overflow="hidden">
      <Grid position="relative">
        <CircularSkeleton width={28} height={28} variant="circular" />
        <Grid position="absolute" top="-3px" right="-3px">
          <CircularSkeleton width={12} height={12} variant="circular" />
        </Grid>
      </Grid>
      <Grid container direction="column" gap="4px">
        <Grid item container justifyContent="space-between" alignItems="center">
          <Grid gap={1} display="flex" flexDirection="row">
            <RoundedSkeleton width={96} height={21} />
          </Grid>
          <RoundedSkeleton width={54} height={9.625} />
        </Grid>
        <Grid display="flex" flexDirection="column" gap="4">
          <RoundedSkeleton width={217} height={11.375} />
          <RoundedSkeleton width={115} height={11.375} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default LoadingConversation;
